import { Link } from 'common/utils/user-tracker/react-router-dom';
import Button from 'common/components/button';
import { useNavigate } from 'react-router-dom';

// This component is specifically for the dashboard messages that we're implementing for activations
// They contain an icon, title, description, and a button that links to an action

const DashboardMessage = ({
  Icon,
  path = '',
  title = '',
  description = '',
  buttonTitle,
}) => {
  const navigate = useNavigate();

  return (
    <Link linkId={typeof title === 'string' ? title : ''} className='w-full' to={path}>
      <div className='h-full grid grid-cols-[auto,1fr] grid-rows-[auto] gap-x-4 gap-y-1 p-5 border border-gray-600 rounded-lg bg-gray-800 text-white'>
        <div className='flex items-center self-center h-fit w-fit row-span-1 p-1 rounded-full bg-gray-600'>
          <Icon className='text-2xl' />
        </div>
        <span className='text-lg font-medium self-center'>{title}</span>
        <p className='text-base col-start-2'>{description}</p>
        <div className='mt-4 col-start-2 self-end'>
          <Button
            theme='secondary'
            wFull={false}
            size='sm'
            title={buttonTitle ?? title}
            className=''
            onClick={() => navigate(path)}
          />
        </div>
      </div>
    </Link>
  );
};

export default DashboardMessage;
